import { t } from '@lingui/macro';
import { Alert } from '@pocketlaw/tetris';
export function SubmitAlert() {
    return (<Alert appearance="danger" message={t({
            message: 'Could not save signing parties, please try again',
            comment: 'Error message for saving template default signatories',
        })}/>);
}
